<style lang="scss" scoped>
  @import "details";
  .search-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-form-item{
      margin-bottom:8px;
    }
    .el-input{
      width:130px;
    }
  }
  .download{
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .order-time{
    /deep/ .el-date-editor{
      width: 200px;
      padding:3px 0px 3px 3px;
      .el-range__close-icon{
        font-size: 12px;
        width: 17px;
      }
      .el-range-separator{
        padding:0;
        width: 18px;
      }
    }
  }
  .range-search{
    /deep/ .el-select{
      width: 105px;
    }
    
  }
   
</style>
  
<style>
  .sanger-search-top .el-form-item__label{
    padding-right:2px !important;
  }
</style>

<template>
  <div class="user-details">
    <section class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/user' }">用户中心</el-breadcrumb-item>
        <el-breadcrumb-item><router-link to="/user/sanger">测序订单</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>测序订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 class="title">Sanger测序反应结果综合查询</h3>
      <p class="text-gray9">测序结果为您保存6个月，超期将无法下载，请您及时下载并备份测序结果</p>
      <div class="search-top mt20">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="下单时间：">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="样品名称：">
            <el-input v-model="searchForm.demoName" placeholder="请输入样品名称"></el-input>
          </el-form-item>
          <el-form-item label="引物名称：">
            <el-input v-model="searchForm.primerName" placeholder="请输入引物名称"></el-input>
          </el-form-item>
          <el-form-item label="数据范围：" class="range-search">
              <el-select v-model="searchForm.isHis" placeholder="请选择">
                <el-option label="实时数据" :value="0"></el-option>
                <el-option label="历史数据" :value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="结果下载状态：">
            <el-select v-model="searchForm.officialDownloadResultFlag" filterable clearable>
              <el-option
                  v-for="item in officialDownloadResultFlag"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首次结果上传时间：" class="date">
            <el-date-picker
              v-model="searchForm.firstResultUploadTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getReaction">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="download">
        <el-button type="primary" @click="getWorkerDoc('')">结果下载</el-button>
        <el-button type="primary" @click="getWorkerJion()">拼接文件下载</el-button>
        <span class="text-gray9 ml20">点击样品名称可直接打包下载对应样品反应结果</span>
      </div>
      <el-table
        border
        class="mt20"
        :data="reactionLists"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="value.no"
          label="订单编号">
        </el-table-column>
        <el-table-column
          label="样品名称">
          <template slot-scope="scope"><span class="text-primary pointer" @click="getWorkerDoc(scope.row.value.id)">{{scope.row.value.demo.name}}</span></template>
        </el-table-column>
        <el-table-column
          prop="value.demoType"
          label="样品类型">
        </el-table-column>
        <el-table-column
          prop="value.primer.authenticateResultName"
          label="鉴定状态">
        </el-table-column>
        <el-table-column
          prop="value.primer.name"
          label="引物名称">
        </el-table-column>
        <el-table-column
          prop="value.testResultName"
          label="测通结果">
        </el-table-column>
        <el-table-column
          prop="value.reactionStatusName"
          label="反应状态">
        </el-table-column>
        <el-table-column
          prop="value.reactionlTypeName"
          label="反应类型">
        </el-table-column>
        <el-table-column
          prop="value.returnStatusName"
          label="返样状态">
        </el-table-column>
        <el-table-column
          prop="date"
          label="下单时间">
          <template slot-scope="scope">{{scope.row.value.createTime | rTime}}</template>
        </el-table-column>
        <el-table-column label="首次结果上传时间" width="100">
					<template slot-scope="scope">{{
							scope.row.value.order.firstResultUploadTime | rTime
					}}</template>
				</el-table-column>
        <el-table-column label="结果下载状态" width="100">
					<template slot-scope="scope">
            <span>{{scope.row.value.order.officialDownloadResultFlag?'已下载':'未下载'}}</span>
					</template>
				</el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :total="total"
          :page-sizes="[10, 20, 50, 100, 200, 500]"
          @size-change="changeSize"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
  import { sequencingWorkOrders, sangerWorderDoc, sangerWorderJoin } from '@/services/api.index'
  const officialDownloadResultFlag = [
    { label: "未下载", value: false },
    { label: "已下载", value: true },
  ]
  export default {
  data () {
    return {
      officialDownloadResultFlag,
      searchForm: {
        primerName: '',
        demoName: '',
        orderNo: '',
        date: null,
        isHis:0
      },
      reactionLists: [],
      effectTable: [],
      total: 0,
      page: 0,
      size: 10,
      multipleSelection: []
    }
  },
  created () {
    this.getReaction()
  },
  methods: {
    //拼接文件下载
    getWorkerJion() {
      if (this.multipleSelection.length === 0) {
        return this.$message.warning('请选择工单')
      }
      let ids = this.multipleSelection.map((item) => item.value.id)
      sangerWorderJoin(ids).then((res) => {
        this.baseMethods.downloadFile(
          res.data,
          `拼接文件${this.baseMethods.dateToString}`,
          'zip'
        )
      })
    },
    // 订单包含反应信息
    getReaction () {
      let { demoName, primerName, orderNo, date, isHis, firstResultUploadTime, officialDownloadResultFlag } = this.searchForm
      date = date || ['', '']
      firstResultUploadTime = firstResultUploadTime || ['', '']
      const customerId = this.baseMethods.getLocalObj('memberInfo').id
      sequencingWorkOrders(this.page, this.size, date[0], date[1], orderNo, primerName, demoName, customerId,isHis, ...firstResultUploadTime, officialDownloadResultFlag).then(res => {
        res.data.list.map(item => {
          item.value.reactionStatusName = this.baseMethods.reactionStatus(item.value.status)
          item.value.reactionlTypeName = this.baseMethods.reactionType(item.value.reactionlType)
          item.value.primer.authenticateResultName = this.baseMethods.authenticateResult(item.value.primer.authenticateResult)
          item.value.returnStatusName = this.baseMethods.returnStatus(item.value.demo.userReturnDemoStatus)
          item.value.testResultName = this.baseMethods.testResult(item.value.demo.result)
          item.value.demoType = this.baseMethods.demoType(item.value.demo.plate.type)
        })
        this.reactionLists = res.data.list
        // this.reactionTotal = res.data.totalCount
        this.total = res.data.totalCount
      })
    },
    // 反应信息多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 工单下载
    getWorkerDoc () {
      const { multipleSelection } = this
      if (multipleSelection.length === 0) {
        return this.$message.warning('请选择订单')
      }
      let ids = []
      multipleSelection.map(item => {
        ids.push(item.value.id)
      })
      sangerWorderDoc(ids).then(res => {
        this.baseMethods.downloadFile(res.data, `结果文件${this.baseMethods.dateToString()}`, "zip")
      })
    },
    changePage (value) {
      this.page = value - 1
      this.getReaction()
    },
    changeSize (value) {
      this.size = value
      this.getReaction()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/sanger_search.vue